<template>
  <v-app class="platform-font">
    <main-app-bar />
    <v-main :full-screen="$root.fullScreenView">
      <v-row>
        <v-snackbar
          v-model="showSnackbar"
          :color="snackbarColor"
          :timeout="snackbarTimeout"
          content-class="font-weight-bold"
          :top="true"
        >
          {{ snackbarMsg }}
          <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
        </v-snackbar>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import constant from "../../const"
import MainAppBar from "@/components/MainAppBar"
export default {
  components: {
    MainAppBar,
  },
  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,

      xero_auth_code: null,
      xero_auth_state: null,
      xero_auth_error: null,
    }
  },

  async created() {
    this.$root.fullScreenView = false
    this.$root.blockUImsg = "Authenticating xero"
    this.$root.blockUIshow = true

    this.xero_auth_code = this.$route.query.code
    this.xero_auth_state = this.$route.query.state
    this.xero_auth_error = this.$route.query.error

    // verify user token
    await this.$root.verify_user_token()

    await this.xero_auth_exchange_code()
  },

  methods: {
    async xero_auth_exchange_code() {
      this.$root.blockUImsg = "Exchanging xero authentication code"
      let postform = {
        code: this.xero_auth_code,
        redirect_uri: constant.XERO_REDIRECT_URI,
      }

      await this.$root
        .exchange_code_for_xero_access_token(postform)
        .then((resp) => {
          // goto invoices page
          this.$router.replace({
            name: "invoices",
          })
          this.$root.blockUIshow = false
        })
        .catch((err) => {
          if (err.response) {
            console.error(err.response)

            this.snackbarColor = "error"
            this.snackbarMsg =
              err.response.data.error || "Error generating token"
            this.showSnackbar = true
          }
          this.$root.blockUIshow = false
        })
      this.$root.blockUIshow = false
    },
  },
}
</script>

<style scoped>
</style>